module.exports = __webpack_public_path__ + "static/Carly_Daniel12-404467bdf25d64fecb5ee096e45d008a.jpg";